module.exports = __webpack_public_path__ + "img/twitter.7949ab96.svg";